import { SIZE_MAP as i, FALLBACK_MAP as o } from "../constants.js";
const L = ["inset"], p = (t = "", r = "padding") => (t == null ? void 0 : t.split(" ").map((n) => {
  const A = n in i, c = n in o, s = L.includes(r);
  return A ? `var(--${r}-${i[n]})` : c ? o[n] : s ? n : 0;
}).join(" ")) || void 0;
export {
  p as getCSSValue
};
